// extracted by mini-css-extract-plugin
export default {"fieldContainer":"Field_fieldContainer__1uc0e","fieldTitle":"Field_fieldTitle__IpKQn","fieldText":"Field_fieldText__N7rAe"};